// extracted by mini-css-extract-plugin
module.exports = {"section":"MapRestMenu_section__rX1vY","header":"MapRestMenu_header__2Smet","title":"MapRestMenu_title__xjwoI","slider":"MapRestMenu_slider__0jCjC"};